export default __webpack_public_path__ + "static/media/wallet.396de5e8.svg";